import React from 'react'

import { LntSwitch, LntInput, LntSelect } from '@app/components/base'
import { RendererWrapper } from '@app/components/renderers'

import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'
import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { SIZE } from '@app/constants'

import { columnSettingSchema, columnTitleSchema } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { RegistryArchiveListDataSource } from '../types'

const getOptions = (): Array<Column<RegistryArchiveListDataSource>> => {
  const columnsKeys = Object.keys(columnTitleSchema).filter(
    key =>
      !['isEPP', 'isCHTM', 'howToMonitor', 'isRecalculation', 'isShortKvi', 'isTop1', 'isInfo', 'subtypes'].includes(
        key
      )
  ) as Array<keyof RegistryArchiveListDataSource>

  return columnsKeys.map(key => {
    const column: Column<RegistryArchiveListDataSource> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key]),
      ...columnSettingSchema[key]
    }

    return column
  })
}

export const getColumns = (): Array<Column<RegistryArchiveListDataSource>> => {
  return getColumnsFromMap<RegistryArchiveListDataSource>({
    columnTitleMap: columnTitleSchema,
    options: [
      ...getOptions(),
      {
        key: 'isEPP',
        sorter: (a, b) => sorterDispatcher(a.isEPP, b.isEPP),
        render: (_, { isEPP }) => (
          <LntSwitch
            size={ SIZE.small }
            checked={ isEPP }
            disabled
          />
        )
      },
      {
        key: 'isCHTM',
        sorter: (a, b) => sorterDispatcher(a.isCHTM, b.isCHTM),
        render: (_, { isCHTM }) => <span>{ isCHTM ? 'Да' : '' }</span>
      },
      {
        key: 'howToMonitor',
        sorter: (a, b) => sorterDispatcher(a.howToMonitor, b.howToMonitor),
        render: (_, { howToMonitor }) => (
          <RendererWrapper
            minWidth={ 200 }
            maxWidth={ 250 }
          >
            <LntInput
              disabled
              placeholder='Введите текст'
              size={ SIZE.small }
              defaultValue={ howToMonitor }
            />
          </RendererWrapper>
        )
      },
      {
        key: 'isRecalculation',
        sorter: (a, b) => sorterDispatcher(a.isRecalculation, b.isRecalculation),
        render: (_, { isRecalculation }) => (
          <LntSwitch
            disabled
            size={ SIZE.small }
            checked={ isRecalculation }
          />
        )
      },
      {
        key: 'isShortKvi',
        sorter: (a, b) => sorterDispatcher(a.isShortKvi, b.isShortKvi),
        render: (_, { isShortKvi }) => (
          <LntSwitch
            disabled
            size={ SIZE.small }
            checked={ isShortKvi }
          />
        )
      },
      {
        key: 'isTop1',
        sorter: (a, b) => sorterDispatcher(a.isTop1, b.isTop1),
        render: (_, { isTop1 }) => (
          <LntSwitch
            disabled
            size={ SIZE.small }
            checked={ isTop1 }
          />
        )
      },
      {
        key: 'isInfo',
        sorter: (a, b) => sorterDispatcher(a.isInfo, b.isInfo),
        render: (_, { isInfo }) => (
          <LntSwitch
            disabled
            size={ SIZE.small }
            checked={ isInfo }
          />
        )
      },
      {
        key: 'subtypes',
        render: (_, { subtypes }) => {
          const defaultValue = getFilterFromEntities(subtypes)

          return (
            <LntSelect
              disabled
              strictValue
              mode='multiple'
              size={ SIZE.small }
              defaultValue={ defaultValue }
            />
          )
        }
      }
    ]
  })
}
